export default new class reviewsExternal {
  constructor() {
    this.reviewsListWrapper = 'reviews__list';

    this.paginationWrapper = 'reviews-btn__wrapper';
    this.showMoreBtnSelector = 'show-more__btn';

    this.init();
  }

  init() {
    $(document).on('click', `.${this.showMoreBtnSelector}`, (obEvent) => {
      const obButton = $(obEvent.currentTarget);
      const iPage = obButton.attr('data-page');
      const iMaxPage = obButton.attr('data-max-page');
      // eslint-disable-next-line no-console
      console.log(iPage);

      $.request('onAjax', {
        data: {
          iPage,
          iMaxPage,
        },
        update: {
          'content/reviews/reviews-external/reviews-external-list-ajax': `@.${this.reviewsListWrapper}`,
          'content/reviews/reviews-external/reviews-external-pagination': `.${this.paginationWrapper}`,
        },
      });
    });
  }
}();
